import React from 'react'
import {MarkdownDisplay} from '/app/src/component'

import style from './style.css'

/*
    Props:
        - authorName
        - authorImg
        - dateModified
        - question
        - answer
        - color
        - companyName
*/

export default class HelpDeskItemPreview extends React.Component {
    _renderProfile() {
        let { authorName, authorImg, dateModified } = this.props;
        if(!dateModified){
            dateModified= 'Idag ' +(new Date().toLocaleTimeString())
        }

        return (
            <div>
                {authorImg && <img className={style.ProfilePicture}
                alt=''
                src={authorImg}/>}
                <div className={style.ProfileMetaText}>
                    {authorName &&
                        <div> Skriven av: { authorName } </div>}
                    <div> Uppdaterad: { dateModified || 'Idag' }</div>
                </div>
            </div>
        )
    }

    _renderText() {
        const { question, answer } = this.props;
        return (
            <div className={style.ArticleTextContainer}>
                <div className={style.Title}> {question} </div>
                <div className={style.BodyText}>
                     <MarkdownDisplay text={answer}/>
                </div>
            </div>
        )
    }

    _renderHeader() {
        const { color, companyName } = this.props;
        return (
            <div className={style.Header} style={{backgroundColor: color || '#4DC1E0' }}>
                <div className={style.CompanyName}> {companyName || 'Company Name'} </div>
                <div className={style.HeaderTitle}> Helpdesk </div>
            </div>
        )
    }

    render() {
        return (
            <div className={style.Container}>
                {this._renderHeader()}
                <div className={style.ArticlePage}>
                    <div className={style.ArticleContainer}>
                        {this._renderText()}
                        {this._renderProfile()}
                        <div className={style.BackLink}>
                             {'< Tillbaka'}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Preview/ClientChat/HelpDeskItem/index.js